import { EndpointRequest } from "../../_system/EndpointRequest";
import {
  CancelReservingRequestDto as RequestDto,
  CancelReservingResponseDto as ResponseDto,
} from "../../api/instanceReservation/cancel/dtos";
import { Api } from "../../api";

type CallParams = string[];
type Data = number[];

export const cancelReservation = new EndpointRequest<
  RequestDto,
  ResponseDto,
  Data,
  CallParams
>(
  "CANCEL_RESERVATION_ACTIVITY",
  Api.instanceReservation.cancel,
  undefined,
  (ids) => {
    return {
      instances: ids,
    };
  }
);
